export default __webpack_public_path__ + "static/media/tamato3.3a4189b5.png";